<div class="delete-notification">
  <h2 class="headline">
    {{'NOTIFICATION_PAGE.MODAL_DELETE_ALL.TITLE' | translate}}
  </h2>
  <p class="description">
    {{'NOTIFICATION_PAGE.MODAL_DELETE_ALL.DESCRIPTION' | translate}}
  </p>
  <div class="btn-block">
    <button
      (click)="deletePaylink()"
      class="btn btn-danger">
      {{'NOTIFICATION_PAGE.MODAL_DELETE_ALL.DELETE' | translate}}
    </button>
    <button
      (click)="closeModal()"
      class="btn btn-light">
      {{'NOTIFICATION_PAGE.MODAL_DELETE_ALL.CANCEL' | translate}}
    </button>
  </div>
</div>
